import { useQuery } from "@tanstack/react-query";

import { MODULE_NAMES } from "@/constants/modules";
import { TEN_MINUTES_MS } from "@/constants/time";

import { fetchClientAppsListData } from "./clientAppsApi";
import { type ClientAppDto } from "./types";

export const useClientApps = () =>
  useQuery({
    queryKey: [MODULE_NAMES.CLIENT_APPS],
    queryFn: async () => {
      const data = (await fetchClientAppsListData()) || [];

      return {
        clientAppsList: data,
        clientAppsObject: data.reduce<Record<string, ClientAppDto>>(
          (acc, app) => {
            acc[app.id || ""] = app;
            return acc;
          },
          {},
        ),
      };
    },
    staleTime: TEN_MINUTES_MS,
  });
